angular.module('zc.core')
  .factory('baseChartV2Config', baseChartV2Config);

baseChartV2Config.$inject = [];
function baseChartV2Config() {
  return {
    options: {
      title: { text: null },
      legend: { enabled: false },
      credits: { enabled: false }
    },
    series: []
  };
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/base_chart_v2_config.service.js